import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "./components/Layout";
import HomePage from "./pages/HomePage";
import BoilerServicesPage from "./pages/BoilerServicesPage";
import LandlordServicesPage from "./pages/LandlordServicesPage";
import GasHeatingPage from "./pages/GasHeatingPage";
import PlumbingServicesPage from "./pages/PlumbingServicesPage";
import AreasCoveredPage from "./pages/AreasCoveredPage";
import ReviewsPage from "./pages/ReviewsPage";
import FaqPage from "./pages/FaqPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/boiler-services" element={<BoilerServicesPage />} />
              <Route path="/landlord-services" element={<LandlordServicesPage />} />
              <Route path="/gas-heating" element={<GasHeatingPage />} />
              <Route path="/plumbing-services" element={<PlumbingServicesPage />} />
              <Route path="/areas-covered" element={<AreasCoveredPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
